import SubMenu from './SubMenu';

export { SubMenu };
export default SubMenu;
